// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"920b003b","85":"3c0aa72e","103":"e3318865","152":"80f576d7","240":"101d9f97","350":"a9e0ce8b","401":"f344d86e","536":"294acd12","719":"e93c0530"}[chunkId] + ".chunk.js";
};